import { render, staticRenderFns } from "./TipoviVozila.vue?vue&type=template&id=08f3cf9b&scoped=true&"
import script from "./TipoviVozila.vue?vue&type=script&lang=ts&"
export * from "./TipoviVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3cf9b",
  null
  
)

export default component.exports